import * as clients from './Clients';
import * as providers from './Providers';

export const route = {
  path: 'contacts',
  children: [clients.route, providers.route],
};
